import { AccountCategoryVendor, ScheduleVendorAcctCategoryAssoc, TemplateVendorAccountCategory } from "./index";

export class AccountCategory {
    accountCategoryId: number;
    name: string;
    number: string;
    scarStage: string;
    displayText: string;
    groupType: string;
    accountCategoryAssoc?: AccountCategoryVendor;
    templateVendorAccountCategoryAssoc: TemplateVendorAccountCategory;
    ScheduleVendorAcctCategoryAssocs: ScheduleVendorAcctCategoryAssoc[];
}
